import React from 'react'
import i18next from 'i18next'
import { Form } from 'react-bootstrap'
import { formClasses } from '../sharedLayout/forms'
import { Link } from '../../utils/link'
import { getClassName } from '../../utils/utils'
import { GenericPageHeader } from '../sharedLayout/pageheader'
import { navigate } from 'widgets-for-react'

export const NotFoundLayout = (props: {
  searchString: string
  onChangeSearchString: (_: string) => void
  breadcrumbs: { title: string; url: string }[]
}) => (
  <GenericPageHeader
    kind="404"
    breadcrumbs={props.breadcrumbs}
    title={i18next.t('pageNotFound:pageNotFoundTitle')}
    intro={
      <>
        {i18next.t('pageNotFound:pageNotFoundTextA')}{' '}
        <Link url={i18next.language == 'nl' ? '/' : '/en'} className="link--styled">
          {i18next.t('pageNotFound:pageNotFoundTextB')}
        </Link>{' '}
        {i18next.t('pageNotFound:pageNotFoundTextC')}
      </>
    }
    extraJSXBelowIntro={
      <div className="pageheader__cta">
        <Searchbar searchString={props.searchString} onChangeSearchString={props.onChangeSearchString} />
      </div>
    }
  />
)

const Searchbar = (props: {
    searchString: string
    onChangeSearchString: (_: string) => void
  }) => (
    <>
      <form
        className="searchbar"
        onSubmit={(e) => {
          e.preventDefault()
          navigate(`/zoeken?query=${props.searchString}`)
        }}
      >
        <Form.Group controlId="404-search" className={getClassName(formClasses, 'formGroupClassName', '')}>
          <Form.Label className={getClassName(formClasses, 'formLabelClassName', '')}>
            {i18next.t('common:searchOn')}:
          </Form.Label>

          <div className="searchbar__input">
            <Form.Control
              type="search"
              inputMode="search"
              onChange={(e) => props.onChangeSearchString(e.currentTarget.value)}
              className={getClassName(formClasses, 'formInputClassName', '')}
              value={props.searchString}
            />
            <button className="searchbar__button" title={i18next.t('common:search')} type="submit">
              <span className="sr-text">{i18next.t('common:search')}</span>
              <svg aria-hidden="true">
                <use xlinkHref="#icon--SG-zoeken" />
              </svg>
            </button>
          </div>
        </Form.Group>
      </form>
    </>
  )
